import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    const dialog = document.getElementById("infrastructure-demand-modal");
    if (dialog) {
      dialog.showModal();
    }
  }
}
